<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">金融机构信息</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="finacialorgansinfoForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="机构名称" prop="organsBaseInfoModel.orgName">
              <Input v-model="form.organsBaseInfoModel.orgName" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="经营范围" prop="organsBaseInfoModel.orgBusinessScop">
              <Input v-model="form.organsBaseInfoModel.orgBusinessScop" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="机构地址" prop="organsBaseInfoModel.orgAddress">
              <Input v-model="form.organsBaseInfoModel.orgAddress" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="联系人" prop="organsBaseInfoModel.orgContacts">
              <Input v-model="form.organsBaseInfoModel.orgContacts" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="联系电话" prop="organsBaseInfoModel.orgPhone">
              <Input v-model="form.organsBaseInfoModel.orgPhone" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="授权码" prop="upperOrgCode">
              <Input v-model="form.upperOrgCode" :disabled="disable"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit"  v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'finacialorgansinfo-info',
  data () {
    return {
      form: {
        upperOrgCode: '',
        organsBaseInfoModel: {
          orgName: '',
          orgBusinessScop: '',
          orgAddress: '',
          orgContacts: '',
          orgPhone: '',
          orgType: '0'
        }
      },
      isShow: false,
      type: 'add',
      disable: false,
      orgStatusOptions: {},
      profitSharingOptions: {},
      paymentModeOptions: {},
      ruleValidate: {
        'organsBaseInfoModel.orgName': [
          { required: true, message: '机构名称不允许为空', trigger: 'blur' }
        ],
        'organsBaseInfoModel.orgBusinessScop': [
          { required: true, message: '经营范围不允许为空', trigger: 'blur' }
        ],
        'organsBaseInfoModel.orgAddress': [
          { required: true, message: '地址不允许为空', trigger: 'blur' }
        ],
        'organsBaseInfoModel.orgContacts': [
          { required: true, message: '联系人不允许为空', trigger: 'blur' }
        ],
        'organsBaseInfoModel.orgPhone': [
          { required: true, message: '联系电话不允许为空', trigger: 'blur' }
        ],
        'upperOrgCode': [
          { required: true, message: '授权码不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      this.$refs.finacialorgansinfoForm.resetFields()
      if (data) {
        this.P('admin/finacialorgansinfo/getDetailById/' + data.id).then(data => {
          this.form = data
        })
      } else {
        this.form = {
          organsBaseInfoModel: {
            orgName: '',
            orgBusinessScop: '',
            orgAddress: '',
            orgContacts: '',
            orgPhone: '',
            orgType: '0'
          }
        }
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.finacialorgansinfoForm.validate((valid) => {
        this.form.organsBaseInfoModel.orgType = '0'
        if (valid) {
          switch (this.type) {
            case 'create':
              this.C('admin/finacialorgansinfo', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
            case 'update':
              this.U('admin/finacialorgansinfo', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
          }
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
